export default __webpack_public_path__ + "static/media/T-shirt1.29cd6f41.jpg";